import { render, staticRenderFns } from "./html02.vue?vue&type=template&id=d0c0ba80&scoped=true"
import script from "./html02.vue?vue&type=script&lang=js"
export * from "./html02.vue?vue&type=script&lang=js"
import style0 from "./html02.vue?vue&type=style&index=0&id=d0c0ba80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c0ba80",
  null
  
)

export default component.exports